module.exports = __webpack_public_path__ + "static/img/weathericons-regular-webfont.ecaf8b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-icons/font/weathericons-regular-webfont.svg
// module id = Pt95
// module chunks = 1